import React, { useEffect, useState } from "react";
import { AuthPaymentContainer } from "../../authenticated-payments/misc/auth-payment-container.component";
import { AuthContinue } from "../../authenticated-payments/misc/auth-continue.component";
import { AuthRestartButton } from "../../authenticated-payments/misc/restart-button.component";
import { Field, reduxForm } from "redux-form";
import StylizedRadioGroup from "../../authenticated-payments/misc/stylized-radio-group.component";
import Show from "../../../utils/show.component";
import { number, required } from "../../../utils/formValidators";
import { renderField } from "../../../utils/renderField";
import { connect } from "react-redux";
import TravelExemptionDenied from "../misc/travel-exemption-denied.component";
import {
  callConfirmMfaCode,
  callGetMfaOptions,
  callSubmitMfaPreference,
} from "../../../actions/mfa.actions";
import { CardControlsRestartButton } from "../misc/card-controls-restart-button.component";

const TravelExemptionMfaFormComponent = (props) => {
  const { advanceToNextStep,backToLoans } = props;
  const [formStep, setFormStep] = useState(0);
  const [incorrectCode, setIncorrectCode] = useState(false);
  const [submitMfaPreferenceErrorMessage, setSubmitMfaPreferenceErrorMessage] = useState("");

  const mfaOptions = props.mfa.options;

  useEffect(() => {
    props.callGetMfaOptions();
  }, []);

  const mapOptions = (optionsArray, type) => {
    return optionsArray.map((option) => {
      // Set the value of the radio button to be the key/identifier of the option
      // We need to include the type of option in the identifier because the same identifier
      // can be used for both email and phone options
      const combinedValueIdentifier = `${option.Key}_${type}`;

      return {
        label: option.Value,
        value: combinedValueIdentifier,
        id: combinedValueIdentifier,
      };
    });
  };

  const emailOptions = mapOptions(mfaOptions.emailAddresses, "email");
  const phoneOptions = mapOptions(mfaOptions.phoneNumbers, "sms");

  const hasEmailOptions = emailOptions.length > 0;
  const hasPhoneOptions = phoneOptions.length > 0;

  const fieldError =
    props.thisForm &&
    props.thisForm.fields &&
    props.thisForm.fields["mfaLocation"] &&
    props.thisForm.fields["mfaLocation"].touched &&
    props.thisForm.syncErrors &&
    props.thisForm.syncErrors["mfaLocation"];

  const submitForm = () => {
    window.scrollTo(0, 0);

    switch (formStep) {
      case 0:
        submitMfaPreference(true);
        break;
      case 1:
        submitMfaCode();
        break;
      default:
        break;
    }
  };

  const submitMfaCallback = (result) => {
    setSubmitMfaPreferenceErrorMessage(result.ErrorMessage);
    if (result.ErrorMessage === null || result.ErrorMessage === "") {
      setFormStep(1);
    }
  };

  const submitMfaPreference = (withCallback) => {
    const mfaLocationCombinedIdentifier = props.thisForm.values.mfaLocation;
    const splitIdentifierArray = mfaLocationCombinedIdentifier.split("_");
    const localKey = splitIdentifierArray[0];
    const method = splitIdentifierArray[1];

    if (withCallback) {
      return props.callSubmitMfaPreference(method, localKey, submitMfaCallback);
    } else {
      return props.callSubmitMfaPreference(method, localKey);
    }
  };

  const submitMfaCode = () => {
    setIncorrectCode(false);

    props.callConfirmMfaCode(props.thisForm.values.mfaCode, confirmCodeCallback);
  };

  if (props.mfa.hasReachedMax) {
    return <TravelExemptionDenied backToLoans={backToLoans}/>
  }
  
  const confirmCodeCallback = (response) => {
    if (response.Success) {
      // Advance the step of the flow parent to the next step
      advanceToNextStep();
    }

    if (!response.Success) {
      setIncorrectCode(true);
    }
  };

  const incorrectCodeMessage = incorrectCode ? "The code you entered is incorrect." : "";

  const resendCodeElement = (
    <span className="text-primary" onClick={() => submitMfaPreference(false)}>
      Resend Code
    </span>
  );

  const title = formStep === 0 ? "Verify Your Identity" : "Enter Confirmation Code";
  const subtitle =
    formStep === 0 ? (
      <span>
        We just need to verify who you are. How would you like to receive your confirmation code?
      </span>
    ) : (
      <span>Verify the confirmation code you received.</span>
    );

  const submitMfaPreferenceError = (
    <span>
      {submitMfaPreferenceErrorMessage}
    </span>
  );

  return (
    <AuthPaymentContainer title={title} subtitle={subtitle}>
      <form onSubmit={props.handleSubmit(submitForm)}>
        <Show condition={formStep === 0}>
          <Show condition={hasEmailOptions}>
            <h6 className="my-2">Email Me</h6>
            <StylizedRadioGroup
              fieldGroupName="mfaLocation"
              radioOptions={emailOptions}
              thisForm={props.thisForm}
              change={props.change}
              includeHighlighting={true}
              omitFieldError={true}
            />
          </Show>
          <Show condition={hasPhoneOptions}>
            <h6 className="my-2">Text Me</h6>
            <StylizedRadioGroup
              fieldGroupName="mfaLocation"
              radioOptions={phoneOptions}
              thisForm={props.thisForm}
              change={props.change}
              includeHighlighting={true}
              omitFieldError={true}
            />
          </Show>
          <div className="mt-2 mb-2" style={{ color: "red", fontStyle: "italic" }}>
            {submitMfaPreferenceError}
          </div>
          <div className="mt-2 mb-2" style={{ color: "red", fontStyle: "italic" }}>
            {fieldError}
          </div>
          <div className="mt-3">
            Message and data rates apply for text option. If you need help or information, please
            call us at <span className="bold">888.267.7200</span>.
          </div>
        </Show>
        <Show condition={formStep === 1}>
          <div>Enter code</div>
          {/* Input for a five-digit mfa code */}
          <Field
            name="mfaCode"
            component={renderField}
            type="text"
            validate={[required, number]}
            className="form-control"
          />
          <div className="mt-4 mb-2" style={{ color: "red", fontStyle: "italic" }}>
            {incorrectCodeMessage}
          </div>
          <div>
            If you didn't get a code,
            <span style={{ cursor: "pointer" }}> click {resendCodeElement} </span>
            and we'll send you another one.
          </div>
        </Show>
        <AuthContinue title="Continue" type="submit" disabled={props.submitting} />
        <CardControlsRestartButton backToCards={props.backToLoans} buttonText="Cancel" />
      </form>
    </AuthPaymentContainer>
  );
};

const TravelExemptionMfaFormUnconnected = reduxForm({
  form: "TravelExemptionMfa",
  destroyOnUnmount: false,
  initialValues: {
    mfaLocation: "",
    mfaCode: "",
  },
})(TravelExemptionMfaFormComponent);

const mapStateToProps = (state) => {
  return {
    mfa: state.mfa,
    thisForm: state.form["TravelExemptionMfa"],
  };
};

const mapDispatchToProps = {
  callGetMfaOptions,
  callSubmitMfaPreference,
  callConfirmMfaCode,
};

export const TravelExemptionMfaForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(TravelExemptionMfaFormUnconnected);



// WEBPACK FOOTER //
// ./src/components/card-controls/forms/auth-travel-exemption-mfa-form.component.js